import borders from './borders';
import colors from './colors';

export default {
  colors,
  borders,
};
